import { Component, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { Patient } from 'src/app/core/models';
import { PatientState } from '../core/store/patient/patient.state';

interface TabItem extends MenuItem {
  tabUrl: string;
}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  @Select(PatientState.patient) patient$!: Observable<Patient | null>;
  isPharmPatient: boolean = false;
  tabItems: TabItem[] = [
    {
      label: 'Account Details & Preferences',
      command: this.onTabClick.bind(this, '/profile/patient'),
      tabUrl: '/profile/patient',
      automationId: 'profile-patient-tab',
    },
    {
      label: 'Medical History',
      command: this.onTabClick.bind(this, '/profile/medical'),
      tabUrl: '/profile/medical',
      automationId: 'profile-medical-tab',
    },
    {
      label: 'Insurance',
      command: this.onTabClick.bind(this, '/profile/insurance'),
      tabUrl: '/profile/insurance',
      automationId: 'profile-insurance-tab',
    },
    {
      label: 'Addresses',
      command: this.onTabClick.bind(this, '/profile/addresses'),
      tabUrl: '/profile/addresses',
      automationId: 'profile-addresses-tab',
    },
    {
      label: 'Payment Methods',
      command: this.onTabClick.bind(this, '/profile/payment'),
      tabUrl: '/profile/payment',
      automationId: 'profile-payment-tab',
    },
  ];

  activeTabItem = this.tabItems[0];

  constructor(private router: Router) {}

  ngOnInit(): void {
    const activeTabItem = this.tabItems.find(
      (tabItem: TabItem) => tabItem.tabUrl.toLowerCase() === this.router.url.toLowerCase()
    );

    if (activeTabItem) this.activeTabItem = activeTabItem;

    this.patient$.subscribe((patient) => {
      if (!!patient && patient.isPharmacyPatient) {
        this.isPharmPatient = true;
      }
    });
  }

  onTabClick(link: string) {
    this.router.navigate([link]);
  }
}
